import Vue from 'vue';
import Component from 'vue-class-component';
import ABaseComponent from "Components/Base/ABaseComponent";
import cart from 'Store/cart/cart';
@Component({})
export default class CheckoutComponent extends ABaseComponent{
    get erpError():boolean{
        return cart.state.error;
    }
}
Vue.component('checkout', CheckoutComponent);